import { useLocation } from '@reach/router';

import { getCurrentLanguage } from './helpers';

export const useCurrentLanguage = () => {
  const { search } = useLocation();

  return getCurrentLanguage(search);
};
